import * as actions from "../actionTypes";

export const QUESTION_DATA_LIST = [
  {
    questionNumber: 1, //HARP
    question: "Pay for own heat",
    questionFrench: "Vous payez vos frais de chauffage",
    // question: "Over the age of 65",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 2, //HARP
    question: "Received a letter from Service Nova Scotia",
    questionFrench: "Vous avez reçu une lettre de Service Nouvelle-Écosse",
    questionAnswer: ""
  },
  {
    questionNumber: 3, //HARP
    question:
      "Receive Income Assistance from Department of Community Services",
    // question: "Is the annual household net income less than $37,500?",
    questionFrench: "Vous recevez de l'aide au revenu du ministère des Services communautaires",
    questionAnswer: ""
  },
  {
    questionNumber: 4, //HARP
    question: "Would you like to upload a copy of your heating bill?",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 5, //HARP
    question: "60 years old or older",
    // question: "What is your current living arrangement?",
    questionFrench: "Vous avez 60 ans ou plus",
    questionAnswer: ""
  },
  {
    questionNumber: 6, //HARP
    question: "Receive Guaranteed Income Supplement or Allowance",
    // question: "When is the primary applicant’s date of birth?",
    questionFrench: "Vous recevez le Supplément de revenu garanti ou l'Allocation",
    questionAnswer: ""
  },
  {
    questionNumber: 7, //HARP
    question: "Other adults living in home",
    questionFrench: "D’autres adultes vivent dans le domicile",
    
    // question: "First other adult name",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 8, //HARP
    question: "Household type",
    questionFrench: "Type de ménage",
    // question: "First other adult Social Insurance Number",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 9, //HARP
    question: "Net income in 2023",
    questionFrench: "Revenu net en 2023",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 10, //HARP
    question: "Situation changed since last year",
    questionFrench: "Changement à la situation depuis l’année dernière",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 11,
    question: "Applicant Social Insurance number already used?",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 12,
    question: "Co-Applicant Social Insurance number already used?",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 13, //HARP
    question: "How do you heat your home? ",
    // question: "Current living arrangement id",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 14,
    question: "Continuing without uploading proof of home heating",
    // question: "HARP Duplicate Application",
    questionAnswer: "",
    flag: undefined
  },
  {
    questionNumber: 15,
    question: "Other adult info view message question",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 16, //HARP
    question: "Income Amount",
    questionFrench: "Est-ce qu’un autre adulte habite avec vous?",
    questionAnswer: ""
  },
  {
    questionNumber: 17, //used
    question:
      "Does the other family member live in the same unit as the primary applicant?",
    questionFrench:
      "Est-ce que l’autre membre de votre famille habite dans le même logement que vous?",
    questionAnswer: ""
  },
  {
    questionNumber: 18, //used
    question: "Does the other family member earn an income?",
    questionFrench: "Est-ce que l’autre membre de votre famille a un revenu?",
    questionAnswer: ""
  },
  {
    questionNumber: 19, //used
    question: "Other family member contribute to household expenses an income",
    questionAnswer: "",
    flag: false
  },
  {
    questionNumber: 20, //used
    question: "Have you filed your 2022 personal income tax return?",
    questionFrench:
      "Avez-vous produit une déclaration de revenus personnelle pour 2022?",
    questionAnswer: ""
  },
  {
    questionNumber: 21, //used
    question:
      "Will you spend $750 on household or healthcare services or home heating costs between 1 April 2023 and 31 March 2024? ",
    questionFrench:
      "Avez-vous dépensé 750 $ pour des services à domicile et de services de soins de santé ou coûts de chauffage depuis le 1er avril 2023?",
    questionAnswer: ""
  },
  // {
  //   questionNumber: 22, //used
  //   question:
  //     "I understand that Service Nova Scotia may contact me for additional information about the household or healthcare services or home heating costs.",
  //   questionFrench:
  //     "Je comprends que Service Nouvelle-Écosse peut communiquer avec moi pour me demander des renseignements supplémentaires au sujet des services à domicile et de services de soins de santé ou coûts de chauffage reçus.",
  //   questionAnswer: "Yes"
  // }
];
export const MAILING_ADDRESS_SAME = "MAILING_ADDRESS_SAME";
export const MAILING_ADDRESS_DIFFERENT = "MAILING_ADDRESS_DIFFERENT";
export const MAILING_OPTIONS = {
  [MAILING_ADDRESS_SAME]: "mailing_address.mailing_address_same",
  [MAILING_ADDRESS_DIFFERENT]: "mailing_address.mailing_address_different"
};

export const initialHomeAddress = {
  streetAddress: "",
  // civicId: "",
  // apartment: "",
  city: "",
  province: "NS",
  postalCode: ""
};

export const initialMailingAddress = {
  street: "",
  // apartment: "",
  city: "",
  provinceState: "NS",
  postalCode: ""
};

export const initialPersonalInformation = {
  firstName: "",
  lastName: "",
  socialInsuranceNumber: "",
  dateOfBirth: null,
  email: "",
  phone: "",
  altPhone: "",
  textAllowedAtPhoneNumber: "",
  ageError: false
};

export const initialDOB = {
  dateOfBirth: null
};

export const initalOtherAdult = {
  firstName: "",
  lastName: "",
  socialInsuranceNumber: "",
  dateOfBirth: null,
  ageError: false,
  birthYear: "",
  localId: Date.now()
};

// initial state of application
const initialState = {
  personalInformation: { ...initialPersonalInformation },
  dob: { ...initialDOB },
  otherAdultsInformation: [{ ...initalOtherAdult }],
  homeAddress: { ...initialHomeAddress },
  mailingAddress: { ...initialMailingAddress },
  mailingAddressSame: "",
  questionDataList: QUESTION_DATA_LIST,
  authorizeCanadaRevenueAgency: true,
  contactedByEfficiency: false,
  cyberSecurity: false,
  applicantSignature: null,
  otherApplicantSignature: null,
  otherAdultsSignature: {},
  appLanguage: "EN",
  houseOwnOrRent: "",
  heatingBill: [],
  otherAdultAssessmentFiles: {}
};

const updateQuestionList = (questionList, payload) => {
  const { questionNumber } = payload;

  const newQuestionList = questionList?.map((q) => {
    if (q.questionNumber === questionNumber) {
      return { ...q, ...payload };
    } else {
      return q;
    }
  });
  newQuestionList.sort((a, b) => b.questionNumber - a.questionNumber);
  return newQuestionList;

  // const index = questionList.findIndex(
  //   (question) => question.questionNumber === questionNumber
  // );

  // if (index >= 0) {
  //   const q = questionList[index];
  //   questionList.splice(index, 1, { ...q, ...payload });
  // } else {
  //   questionList.push(payload);
  // }

  // questionList.sort((a, b) => b.questionNumber - a.questionNumber);
  // return questionList;
};

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_APP_PROPERTY:
      const { key, value } = action.payload;
      return {
        ...state,
        [key]: value
      };
    case actions.SET_QUESTION_ANSWER:
      const questionList = updateQuestionList(
        state.questionDataList,
        action.payload
      );
      return {
        ...state,
        questionDataList: [...questionList]
      };
    case actions.CLEAR_ALL: {
      return initialState;
    }

    case actions.CHANGE_OBJECT_PROPERTY: {
      return {
        ...state,
        [action.payload.object]: {
          ...state[action.payload.object],
          [action.payload.field]: action.payload.value
        }
      };
    }

    case actions.ADD_NEW_ADULT: {
      return {
        ...state,
        otherAdultsInformation: [
          ...state.otherAdultsInformation,
          { ...initalOtherAdult, localId: Date.now() }
        ]
      };
    }

    case actions.REMOVE_OTHER_ADULT: {
      const localId = action.payload;
      let newList;
      if (state.otherAdultsInformation.length && localId) {
        newList = state.otherAdultsInformation.filter((item) => {
          return item.localId !== localId;
        });
      } else {
        newList = state.otherAdultsInformation;
      }
      return {
        ...state,
        otherAdultsInformation: newList
      };
    }

    case actions.UPDATE_OTHER_ADULT: {
      const otherAdult = action.payload;
      const newList = state.otherAdultsInformation?.map((item) => {
        if (item.localId === otherAdult.localId) {
          return otherAdult;
        }
        return item;
      });

      return {
        ...state,
        otherAdultsInformation: newList
      };
    }

    case actions.SET_OTHER_ADULT_FILES: {
      return {
        ...state,
        otherAdultAssessmentFiles: {
          ...state.otherAdultAssessmentFiles,
          ...action.payload
        }
      };
    }
  
    case actions.REMOVE_FILES: {
      return {
        ...state,
        [action.payload.field]: action.payload.value
      }
    }


    default: {
      return state;
    }
  }
};

export default AppReducer;
